import {
  pricingRuleIdFormat,
  productIdFormat,
} from "@redotech/redo-ids-cockroach";
import * as z from "zod";

const pricingRuleSchema = z.object({
  id: pricingRuleIdFormat.schema,
  name: z.string(),
  priority: z.number(),
  active: z.boolean(),
  products: z.array(
    z.object({
      id: productIdFormat.schema,
      title: z.string(),
      sku: z.string(),
      price: z.number().nullish(),
      currency: z.string().nullish(),
      imageUrl: z.string().nullish(),
    }),
  ),
  thresholds: z.array(
    z.object({ quantity: z.number(), price: z.number(), currency: z.string() }),
  ),
});

export type PricingRule = z.infer<typeof pricingRuleSchema>;

export const getPricingRules = {
  name: "getPricingRules" as const,

  input: z.object({}),

  output: z.object({ pricingRules: z.array(pricingRuleSchema) }),
};
